import React, { useState, useEffect, memo, useCallback } from "react";
import Typography from "@material-ui/core/Typography";
import { TextField } from "@material-ui/core";
import "react-responsive-modal/styles.css";
import SendIcon from "@material-ui/icons/Send";
import Chip from "@material-ui/core/Chip";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { getLocalStorage } from "components/Helper/Helper";
 import "./style.css";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import VendorBootTable from "./VendorBootTable";
import { connect } from "react-redux";
import { RingLoader } from "react-spinners";
import swal from "sweetalert";
import { compose } from "redux";
import { toast } from "react-toastify";
import { COMMON_MSGS } from "Constant/Messages";
import { successToastMessage, errorToastMessage } from "utils/errorToast";
import { getVendorListData, sendEmailToVendors } from "../action";

const testEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

const ComposeMail = ({
  loaderStatus=false,
  vendorList,
  getVendorListData,
  sendEmailToVendors,
  selectedRow,
  closeMailModal,
  profileData,
}) => {
  const [toEmails, setToEmails] = useState([]);
  const [ccEmails, setCcEmails] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [subject, setSubject] = useState("GSTR-2A_2B Reco Report");
  const [emailBody, setEmailBody] = useState(
    `<!DOCTYPE html>
        <html>
        <head>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    font-size: 11px;
                }
            </style>
        </head>
        <body>
            <p>Dear Sir/Madam,</p>
            <p><br></p>
            <p>I trust this message finds you in good health. We're delighted to inform you that we have successfully reconciled your invoice details in our ERP with the GSTR-2A_2B records. However, we have identified a discrepancy that requires your attention. The details are provided in the attached report.</p>
            <p><br></p>
            <p>Our commitment to accuracy and transparency remains unwavering, and we aim to assist you in ensuring that your financial records align with GST compliance requirements.</p>
            <p><br></p>
            <p>Thank you for entrusting GTaxPro with your tax reconciliation needs. We value your partnership and are dedicated to delivering exceptional service and expertise. Should you have any queries or require further assistance, please do not hesitate to reach out to us at gtaxpro@in.gt.com.</p>
            <p><br></p>
            <p>Thank you once again for choosing GTaxPro as your trusted partner in financial compliance.</p>
            <p><br></p>
        </body>
        </html>`,
  );
  const [toValue, setToValue] = useState("");
  const [ccValue, setCcValue] = useState("");
  const [showVendorListModal, setShowVendorListModal] = useState(false);
  const [gstinVendorList, setGstinVendorList] = useState([]);
  const [emailVendorList, setEmailVendorList] = useState([]);
  const [vendorGstinMails, setVendorGstinMails] = useState([]);

  const getNameAndEmail = useCallback(() => {
    const selected = { ...selectedRow };
    const profile = profileData.find((item) => item.gstin === selected.GSTIN);
    return profile
      ? {
          name: profile.username,
          email: getLocalStorage("userEmail"),
          gstin: selected.GSTIN,
        }
      : {
          name: "Name not found",
          email: "Email not found",
          gstin: "GSTIN not found",
        };
  }, [profileData, selectedRow]);

  // useEffect(() => {
  //   const userEmail = getLocalStorage("userEmail");
  //   setCcEmails([userEmail]);
  //   const data = selectedRow.GSTIN;
  //   getVendorListData(data).then(() => {
  //     if (vendorList?.length > 0) {
  //       const gstinList = vendorList.map((v) => v.gstin);
  //       const emailList = vendorList.map((v) => v.email);
  //       setGstinVendorList(gstinList);
  //       setEmailVendorList(emailList);
  //     }
  //   });
  // }, []);

  useEffect(() => {
  const userEmail = getLocalStorage("userEmail");
   console.log("userEmail value:", userEmail);
  console.log("userEmail type:", typeof userEmail);
  console.log("userEmail stringified:", JSON.stringify(userEmail));
  // Only add email if it exists and is valid
 if (Array.isArray(userEmail)) {
    // Filter valid emails from the array
    const validEmails = userEmail.filter(email => 
      email && 
      typeof email === 'string' && 
      email.trim() && 
      testEmail.test(email.trim())
    );
    
    // Only set if we have valid emails
    if (validEmails.length > 0) {
      setCcEmails(validEmails);
    }
  } else if (typeof userEmail === 'string') {
    // Handle single string email
    const trimmedEmail = userEmail.trim();
    if (trimmedEmail && testEmail.test(trimmedEmail)) {
      setCcEmails([trimmedEmail]); // Wrap in array
    }
  }
  const data = selectedRow.GSTIN;
  getVendorListData(data).then(() => {
    if (vendorList?.length > 0) {
      const gstinList = vendorList.map((v) => v.gstin);
      const emailList = vendorList.map((v) => v.email);
      setGstinVendorList(gstinList);
      setEmailVendorList(emailList);
    }
  });
}, []);

  const handleDeleteCCChip = (index) => {
    setCcEmails((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCCMail = (e) => {
    const email = e.target.value.trim();
    if (e.key === "Enter" && testEmail.test(email)) {
      e.preventDefault();
      setCcEmails((prev) => [...new Set([...prev, email])]);
      setCcValue("");
    } else if (e.key === "Enter") {
      e.preventDefault();
      errorToastMessage(COMMON_MSGS.EMAIL_INVALID);
    }
  };

  const openVendorListModal = () => setShowVendorListModal(true);
  const closeVendorListModal = () => setShowVendorListModal(false);

  const handleVendorListSubmit = (selectedValues, vendorGstinMails) => {
    const emails = selectedValues.map((item) => item.split("~")[1]);
    setSelectedKeys(selectedValues);
    setToEmails([...new Set(emails)]);
    setVendorGstinMails(vendorGstinMails);
    closeVendorListModal();
  };

  const openSwalMsg = async (e) => {
  e.preventDefault();

  const hasSelectedEmails = toEmails.length > 0;

  // Build initial data
  const commonData = {
    ccRecipient: ccEmails,
    subject,
    body: emailBody,
    batchid: selectedRow.UUID || "",
    ret_period:
      selectedRow.SELECTED_RET_PERIOD ||
      selectedRow.GSTR_2A_2B_PERIOD ||
      selectedRow.PR_PERIOD,
    gstin: selectedRow.GSTIN,
    reco_type: selectedRow.RECO_TYPE,
    entity_name: selectedRow.ENTITY_NAME || "",
    fy: selectedRow.GSTR_2A_2B_FISCAL_YEAR || selectedRow.PR_FISCAL_YEAR || "",
    ra_fy: selectedRow.P_ACROSS_FY && selectedRow.P_ACROSS_FY == 'Y' ? "Yes" : "No",
    tolerance: selectedRow.TOLERENCEINPUT || "",
    fuzzy_logic: selectedRow.FUZZY_LOGIC && selectedRow.FUZZY_LOGIC == 'Y' ? "Yes" : "No",
    incld_unavail_crdt: selectedRow.NONAVAILEDITC && selectedRow.NONAVAILEDITC == 'Y' ? "Yes" : "No",
    clientName: getNameAndEmail().name,
    clientEmail: getNameAndEmail().email,
  };

  if (!hasSelectedEmails) {
    const confirm = await swal({
      title: "Are you sure?",
      text: "Do you want to send email to all vendors?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!confirm) return;

    // Send to all vendors
    const allVendorGstinMails = vendorList.map((v) => ({
      gstin: v.gstin,
      email: [v.email],
    }));

    const allEmails = [...new Set(vendorList.map((v) => v.email))];

    const data = {
      ...commonData,
      gstinVendorList: allVendorGstinMails,
    };

    try {
      const response = await sendEmailToVendors(data);
      if (response.error === 1) {
        errorToastMessage(`${response.data.data}`);
      } else {
        successToastMessage(`${response.data.data}`);
      }
      closeMailModal();
    } catch (err) {
      errorToastMessage("Failed to send email.");
    }

    return;
  }

  // Send to selected vendors
  const modifiedVendorList = [];

  vendorGstinMails.forEach((vendor) => {
    const index = modifiedVendorList.findIndex((v) => v.gstin === vendor.gstin);
    if (index === -1) {
      modifiedVendorList.push({ ...vendor });
    } else {
      modifiedVendorList[index].email = [
        ...new Set([
          ...modifiedVendorList[index].email,
          ...vendor.email,
        ]),
      ];
    }
  });

  const data = {
    ...commonData,
    gstinVendorList: modifiedVendorList,
  };

  try {
    const response = await sendEmailToVendors(data);
    if (response.error === 1) {
      errorToastMessage(`${response.data.data}`);
    } else {
      successToastMessage(`${response.data.data}`);
    }
    closeMailModal();
  } catch (err) {
    errorToastMessage("Failed to send email.");
  }
};

  return (
    <>
      <div className="sweet-loading">
        <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
      </div>
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth="sm"
        open={showVendorListModal}
      >
        <MuiDialogTitle
          disableTypography
          style={{ backgroundColor: "#4f2d7f", color: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h6">Vendor List</Typography>
            <CloseIcon
              onClick={closeVendorListModal}
              style={{ cursor: "pointer", color: "white" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent
          dividers
          contentStyle={{
            width: "80%",
            maxWidth: "none",
          }}
        >
          <VendorBootTable
            handleVendorListSubmit={handleVendorListSubmit}
            vendorListSelectedEmails={selectedKeys}
            data={vendorList}
            vendorGstinMails={vendorGstinMails}
          />
        </MuiDialogContent>
      </Dialog>
      <div style={{ padding: "10px" }}>
        <form>
          <div className="d-flex flex-column">
            <div className="d-flex flex-row">
              <div style={{ width: "10%" }}>
                <button
                  onClick={openSwalMsg}
                  className="send-button"
                  style={{
                    backgroundColor: "#6f42c1",
                    color: "white",
                    height: "68px",
                    border: "none",
                    width: "78%",
                    borderRadius: "8px",
                  }}
                >
                  <SendIcon style={{ marginBottom: "7px" }} />
                  <br />
                  Send
                </button>
              </div>
              <div className="ml-4" style={{ width: "90%" }}>
                <div className="d-flex md-2">
                  <div
                    className="col-md-1 compose-mail-to"
                    onClick={openVendorListModal}
                  >
                    To
                  </div>
                  <div className="col-md-11">
                    <TextField
                      disabled
                      multiline
                      style={{
                        width: "100%",
                        color: "black",
                      }}
                      InputProps={{
                        startAdornment: toEmails.map((item, index) => (
                          <Chip
                            key={item}
                            label={item}
                            color="primary"
                            size="small"
                            style={{
                              backgroundColor: "rgb(111, 66, 193)",
                              marginTop: "2px",
                            }}
                          />
                        )),
                      }}
                      value={toValue}
                    />
                  </div>
                </div>
                <div className="d-flex md-2">
                  <div
                    className="col-md-1"
                    style={{
                      paddingTop: "10px",
                      fontSize: "15px",
                      fontWeight: "800",
                      textAlign: "center",
                    }}
                  >
                    Cc
                  </div>
                  <div className="col-md-11">
                    <TextField
                      multiline
                      style={{
                        width: "100%",
                        color: "black",
                        fontFamily: "GT-Walsheim-medium",
                        fontSize: "14px",
                      }}
                      // InputProps={{
                      //   startAdornment: ccEmails.map((item, index) => (
                      //       <>
                      //     <Chip
                      //       key={item}
                      //       label={item}
                      //       onDelete={() => handleDeleteCCChip(index)}
                      //       color="primary"
                      //       size="small"
                      //       style={{
                      //         backgroundColor: "rgb(111, 66, 193)",
                      //         marginTop: "2px",
                      //       }}
                      //     />
                      //     &nbsp;
                      //     </>
                      //   )),
                      // }}
                      InputProps={{
                        startAdornment: ccEmails
                          .filter(
                            (item) =>
                              item && item.trim() && testEmail.test(item)
                          ) // Filter out empty/invalid emails
                          .map((item, index) => (
                            <React.Fragment key={item}>
                              <Chip
                                label={item}
                                onDelete={() =>
                                  handleDeleteCCChip(ccEmails.indexOf(item))
                                } // Use original index
                                color="primary"
                                size="small"
                                style={{
                                  backgroundColor: "rgb(111, 66, 193)",
                                  marginTop: "2px",
                                }}
                              />
                              &nbsp;
                            </React.Fragment>
                          )),
                      }}
                      value={ccValue}
                      onKeyDown={handleAddCCMail}
                      onChange={(e) => setCcValue(e.target.value)}
                    />
                  </div>
                </div>
                <div className="d-flex">
                  <div
                    className="col-md-1"
                    style={{
                      paddingTop: "11px",
                      fontSize: "15px",
                      fontWeight: "800",
                    }}
                  >
                    Subject
                  </div>
                  <div className="col-md-11">
                    <TextField
                      name="subject"
                      inputProps={{
                        style: { fontSize: "13px", padding: "15px 2px 2px" },
                        readOnly: true,
                      }}
                      style={{ width: "100%" }}
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <ReactQuill
                // readOnly
                value={emailBody}
                onChange={setEmailBody}
                style={{ height: "20em" }}
                modules={{ toolbar: true }}
              />
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  loaderStatus: state.gstr2a2bNewRecoReducer.loaderStatus,
  vendorList: state.gstr2a2bNewRecoReducer.vendorList,
});

const mapDispatchToProps = (dispatch) => ({
  getVendorListData: (data) => dispatch(getVendorListData(data)),
  sendEmailToVendors: (data) => dispatch(sendEmailToVendors(data)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(ComposeMail);
